import { CheckLimitsComponentModule } from '@b2b/common/components/check-limits';
import { ReservationInputComponentModule } from '@b2b/common/components/reservation-input';
import { input, output, TODO } from '@b2b/types/core';
import { WillCallOrderItemsByEventVo } from '@b2b/types/order/api/will-call-order-detail.type';
import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { shouldShowFullPriceLink } from './../../utils/order-validation.utils';

interface OrderServiceType {
  getItemType: (type: string, subType?: string) => string;
}

interface WillCallItemWithQuantity {
  orderItemId?: string;
  itemType?: string;
  itemTypeId?: string;
  itemTypeName?: string;
  quantity?: number;
  unitPrice?: string | number;
  discountedUnitPrice?: string | number;
  subtotal?: number;
  discountedSubtotal?: number;
}

class NewOrderEventTableController {
  static $inject = ['$element', 'OrderService'];

  event = input<WillCallOrderItemsByEventVo>()!;
  isOrganizationOrder = input<boolean>()!;
  membershipId = input<string | null>();
  checkingLimits = input(false);

  onItemQuantityChanged = output<{ item: WillCallItemWithQuantity; quantity: number }>();
  onRemoveItemType = output<{ event: WillCallOrderItemsByEventVo; item: WillCallItemWithQuantity; itemIndex: number }>();
  onReservationError = output<{ $error: TODO }>();
  onReservationSuccess = output<{ item: WillCallItemWithQuantity }>();
  onAddFullPriceItem = output<{ event: WillCallOrderItemsByEventVo; item: WillCallItemWithQuantity; itemIndex: number }>();
  onCheckLimits = output<void>();

  constructor(
    private $element: JQuery,
    private orderService: OrderServiceType,
  ) {}

  $onInit() {
    this.$element.addClass('acme-new-order-event-table');
  }

  private normalizeQuantity(quantity: string | number): number {
    const parsed = parseInt(String(quantity), 10);
    return isNaN(parsed) || parsed < 0 ? 0 : parsed;
  }

  calculatePrice(item: { quantity: string | number; price: TODO; discountedUnitPrice: number }): number {
    const quantity = this.normalizeQuantity(item.quantity);
    const price = quantity * item.discountedUnitPrice;

    return price || 0;
  }

  getItemType(itemType: string): string {
    return this.orderService.getItemType(itemType);
  }

  handleUpdateQuantity(item: WillCallItemWithQuantity, quantity: number): void {
    this.onItemQuantityChanged({ $event: { item, quantity } });
  }

  handleReservationError($error: TODO): void {
    this.onReservationError({ $event: { $error } });
  }

  handleReservationSuccess(item: WillCallItemWithQuantity): void {
    this.onReservationSuccess({ $event: { item } });
  }

  handleRemoveItemType(item: WillCallItemWithQuantity, itemIndex: number): void {
    this.onRemoveItemType({ $event: { event: this.event, item, itemIndex } });
  }

  handleAddFullPriceItem(item: WillCallItemWithQuantity, itemIndex: number): void {
    this.onAddFullPriceItem({ $event: { event: this.event, item, itemIndex } });
  }

  shouldShowFullPriceLink(item: WillCallItemWithQuantity): boolean {
    return shouldShowFullPriceLink(item, this.isOrganizationOrder);
  }
}

export const NewOrderEventTableComponentModule = angular
  .module('acme.view.application.orders.edit.components.new-order-event-table', [
    uiRouter,
    'acme.common.service.order',
    'acme.common.filter.saleChannel',
    'acme.common.directive.counter',
    'acme.common.directive.minus',
    CheckLimitsComponentModule,
    ReservationInputComponentModule,
  ])
  .component('acmeNewOrderEventTable', {
    templateUrl: `views/application/views/orders/edit/components/new-order-event-table/new-order-event-table.component.tpl.html`,
    controller: NewOrderEventTableController,
    controllerAs: '$ctrl',
    bindings: {
      event: '<',
      isOrganizationOrder: '<',
      membershipId: '<',

      onItemQuantityChanged: '&',
      onRemoveItemType: '&',
      onReservationError: '&',
      onReservationSuccess: '&',
      onAddFullPriceItem: '&',
      onCheckLimits: '&',
      checkingLimits: '<',
    },
  }).name;
